require('./bootstrap');

import Vue from 'vue'
import Router from 'vue-router'
import Login from '@/components/auth/Login'
import Dashboard from '@/components/Dashboard'
import UnderConstruction from '@/components/UnderConstruction'
import DaftarProduk from '@/components/produk/ProdukList'
import BuatProduk from '@/components/produk/BuatProduk'
import ProdukDetail from '@/components/produk/ProdukDetail'
//pembelian
import PembelianList from '@/components/pembelian/PembelianList'
import TransaksiPembelian from '@/components/pembelian/TransaksiPembelian'
import TransaksiDetailPembelian from '@/components/pembelian/TransaksiDetail'
import PrintInvoicePembelian from '@/components/pembelian/PrintInvoice'
import PrintSuratJalanPembelian from '@/components/pembelian/PrintSuratJalan'
import CreatePembelianPackingTransaksi from '@/components/pembelian/TransaksiCreatePacking'
import MakePaymentPembelian from '@/components/pembelian/MakePayment'
import PembayaranDetailPembelian from '@/components/pembelian/PaymentDetail'
//penjualan
import PenjualanList from '@/components/penjualan/PenjualanList'
import TransaksiPenjualan from '@/components/penjualan/TransaksiPenjualan'
import TransaksiDetailPenjualan from '@/components/penjualan/TransaksiDetail'
import PrintInvoicePenjualan from '@/components/penjualan/PrintInvoice'
import CreatePenjualanPackingTransaksi from '@/components/penjualan/TransaksiCreatePacking'
import MakePaymentPenjualan from '@/components/penjualan/MakePayment'
import PembayaranDetailPenjualan from '@/components/penjualan/PaymentDetail'
//kontak
import KontakList from '@/components/kontak/KontakList'
import KontakForm from '@/components/kontak/KontakBaru'
import KontakDetail from '@/components/kontak/KontakDetail'

//Produksi
import ProduksiList from '@/components/produksi/ProduksiList'
import ProduksiDetail from '@/components/produksi/ProduksiDetail'

//Laporan
import LaporanPenjualan from '@/components/laporan/Penjualan'
import LaporanPembelian from '@/components/laporan/Pembelian'
import LaporanProduk from '@/components/laporan/Produk'

//user
import UserManagement from '@/components/user/User'
import NewUser from '@/components/user/NewUser'
import UserDetail from '@/components/user/UserDetail'


//Akun
import DaftarAkun from '@/components/daftar/DaftarAkun'
import FormAkun from '@/components/daftar/FormAkun'
import AkunDetail from '@/components/daftar/AkunDetail'
import TransferBalance from '@/components/daftar/TransferBalance'
import LabaRugi from '@/components/laporan/LabaRugi'
import Neraca from '@/components/laporan/Neraca'

//Pembiayaan
import DaftarPembiayaan from '@/components/pembiayaan/Daftar'
import FormPembiayaan from '@/components/pembiayaan/BiayaForm'

//Settings
import PemetaanAkun from '@/components/settings/PemetaanAkun'

import auth from '../components/auth/Auth'
Vue.use(Router)

const router = new Router({
  routes: [
    {
      path: '/',
      name: 'Login',
      component: Login
    },
    {
      path: '/login',
      name: 'Loginout',
      component: Login
    },
    {
      path: '/dashboard',
      name: 'Dashboard',
      component: Dashboard,
      meta: {
        auth : true,
      }
    },
    {
      path: '/laporan',
      name: 'Laporan',
      component: UnderConstruction,
      meta: {
        auth : true,
      }
    },
    {
      path: '/produk/daftar-produk',
      name: 'DaftarProduk',
      component: DaftarProduk,
      meta: {
        auth : true,
      }
    },
    {
      path: '/produk/daftar-produk/buat-produk',
      name: 'BuatProduk',
      component: BuatProduk,
      meta: {
        auth : true,
      }
    },
    {
      path: '/produk/daftar-produk/edit-produk/:id_produk',
      name: 'EditProduk',
      component: BuatProduk,
      meta: {
        auth : true,
      }
    },
    {
      path: '/produk/produk-detail/:id_produk',
      name: 'ProdukDetail',
      component: ProdukDetail,
      meta: {
        auth : true
      }
    },
    {
      path: '/produk/transfer-gudang',
      name: 'TransferGudang',
      component: UnderConstruction,
      meta: {
        auth : true,
      }
    },
    {
      path: '/produk/stok-opname',
      name: 'StokOpname',
      component: UnderConstruction,
      meta: {
        auth : true,
      }
    },
    {
      path: '/produk/history-produksi',
      name: 'HistoryProduksi',
      component: ProduksiList,
      meta: {
        auth : true,
      }
    },
    {
      path: '/produk/produksi-detail/:id_produksi',
      name: 'ProduksiDetail',
      component: ProduksiDetail,
      meta: {
        auth : true,
      }
    },
    {
      path: '/pembelian/pemesanan-pembelian',
      name: 'PemesananPembelian',
      component: TransaksiPembelian,
      meta: {
        auth : true,
      }
    },
    {
      path: '/pembelian/edit-transaksi/:id_transaksi',
      name: 'EditPembelian',
      component: TransaksiPembelian,
      meta: {
        auth : true,
      }
    },
    {
      path: '/pembelian/print-invoice/:id_transaksi',
      name: 'PrintInvoicePembelian',
      component: PrintInvoicePembelian,
      meta: {
        auth : true,
      }
    },
    {
      path: '/pembelian/print-surat-jalan/:id_transaksi',
      name: 'PrintSuratJalanPembelian',
      component: PrintSuratJalanPembelian,
      meta: {
        auth : true,
      }
    },
    {
      path: '/pembelian/list/pemesanan-pembelian-detail/:id_transaksi/:tipe_transaksi',
      name: 'PemesananPembelianDetail',
      component: TransaksiDetailPembelian,
      meta: {
        auth : true,
      }
    },
    {
      path: '/pembelian/list/packing-pembelian-detail/:id_transaksi/:tipe_transaksi',
      name: 'PackingPembelianDetail',
      component: TransaksiDetailPembelian,
      meta: {
        auth : true,
      }
    },
    {
      path: '/pembelian/create-packing-transaksi/:id_transaksi',
      name: 'CreatePembelianPackingTransaksi',
      component: CreatePembelianPackingTransaksi,
      meta: {
        auth : true,
      }
    },
    {
      path: '/pembelian/list/pengiriman-pembelian-detail/:id_transaksi/:tipe_transaksi',
      name: 'PengirimanPembelianDetail',
      component: TransaksiDetailPembelian,
      meta: {
        auth : true,
      }
    },
    {
      path: '/pembelian/list/faktur-pembelian-detail/:id_transaksi/:tipe_transaksi',
      name: 'FakturPembelianDetail',
      component: TransaksiDetailPembelian,
      meta: {
        auth : true,
      }
    },
    {
      path: '/pembelian/list/pembayaran-pembelian-detail/:id_transaksi/:tipe_transaksi',
      name: 'PembayaranPembelianDetail',
      component: PembayaranDetailPembelian,
      meta: {
        auth : true,
      }
    },
    {
      path: '/pembelian/list/selesai-pembelian-detail/:id_transaksi/:tipe_transaksi',
      name: 'SelesaiPembelianDetail',
      component: PembayaranDetailPembelian,
      meta: {
        auth : true,
      }
    },
    {
      path: '/pembelian/transaksi-detail/:id_transaksi',
      name: 'TransaksiDetailPembelian',
      component: TransaksiDetailPembelian,
      meta: {
        auth : true,
      }
    },
    {
      path: '/pembelian/list/pemesanan-pembelian',
      name: 'PemesananPembelianList',
      component: PembelianList,
      meta: {
        auth : true,
      }
    },
    {
      path: '/pembelian/list/packing-pembelian',
      name: 'PackingPembelianList',
      component: PembelianList,
      meta: {
        auth : true,
      }
    },
    {
      path: '/pembelian/list/pengiriman-pembelian',
      name: 'PengirimanPembelianList',
      component: PembelianList,
      meta: {
        auth : true,
      }
    },
    {
      path: '/pembelian/list/faktur-pembelian',
      name: 'FakturPembelianlist',
      component: PembelianList,
      meta: {
        auth : true,
      }
    },
    {
      path: '/pembelian/list/pembayaran-pembelian',
      name: 'PembayaranPembelianlist',
      component: PembelianList,
      meta: {
        auth : true,
      }
    },
    {
      path: '/pembelian/list/selesai-pembelian',
      name: 'SelesaiPembelianList',
      component: PembelianList,
      meta: {
        auth : true,
      }
    },
    {
      path: '/pembelian/buat-pembayaran/:jenis_pembayaran',
      name: 'MakePaymentPembelian',
      component: MakePaymentPembelian,
      meta: {
        auth : true,
      }
    },
    {
      path: '/laporan/pembelian/daftar-pembelian',
      name: 'LaporanDaftarPembelian',
      component: LaporanPembelian,
      meta: {
        auth : true,
      }
    },
    {
      path: '/laporan/pembelian/per-produk',
      name: 'LaporanDaftarPembelianPerProduk',
      component: LaporanPembelian,
      meta: {
        auth : true,
      }
    },
    {
      path: '/laporan/pembelian/per-supplier',
      name: 'LaporanDaftarPembelianPerSupplier',
      component: LaporanPembelian,
      meta: {
        auth : true,
      }
    },
    {
      path: '/penjualan/list/pemesanan-penjualan',
      name: 'pemesananPenjualan',
      component: PenjualanList,
      meta: {
        auth : true,
      }
    },
    {
      path: '/penjualan/list/packing-penjualan',
      name: 'PackingPenjualanList',
      component: PenjualanList,
      meta: {
        auth : true,
      }
    },
    {
      path: '/penjualan/list/pengiriman-penjualan',
      name: 'pengirimanPenjualan',
      component: PenjualanList,
      meta: {
        auth : true,
      }
    },
    {
      path: '/penjualan/list/faktur-penjualan',
      name: 'FakturPenjualan',
      component: PenjualanList,
      meta: {
        auth : true,
      }
    },
    {
      path: '/penjualan/list/pembayaran-penjualan',
      name: 'PembayaranPenjualan',
      component: PenjualanList,
      meta: {
        auth : true,
      }
    },
    {
      path: '/penjualan/buat-pembayaran/:jenis_pembayaran',
      name: 'MakePaymentPenjualan',
      component: MakePaymentPenjualan,
      meta: {
        auth : true,
      }
    },
    {
      path: '/penjualan/list/selesai-penjualan',
      name: 'SelesaiPenjualan',
      component: PenjualanList,
      meta: {
        auth : true,
      }
    },
    {
      path: '/penjualan/pemesanan-penjualan',
      name: 'PemesananPenjualan',
      component: TransaksiPenjualan,
      meta: {
        auth : true,
      }
    },
    {
      path: '/penjualan/edit-transaksi/:id_transaksi',
      name: 'EditPenjualan',
      component: TransaksiPenjualan,
      meta: {
        auth : true,
      }
    },
    {
      path: '/penjualan/list/pemesanan-penjualan-detail/:id_transaksi/:tipe_transaksi',
      name: 'PemesananPenjualanDetail',
      component: TransaksiDetailPenjualan,
      meta: {
        auth : true,
      }
    },
    {
      path: '/penjualan/list/packing-penjualan-detail/:id_transaksi/:tipe_transaksi',
      name: 'PackingPenjualanDetail',
      component: TransaksiDetailPenjualan,
      meta: {
        auth : true,
      }
    },
    {
      path: '/penjualan/list/pengiriman-penjualan-detail/:id_transaksi/:tipe_transaksi',
      name: 'PengirimanPenjualanDetail',
      component: TransaksiDetailPenjualan,
      meta: {
        auth : true,
      }
    },
    {
      path: '/penjualan/list/faktur-penjualan-detail/:id_transaksi/:tipe_transaksi',
      name: 'FakturPenjualanDetail',
      component: TransaksiDetailPenjualan,
      meta: {
        auth : true,
      }
    },
    {
      path: '/penjualan/list/pembayaran-penjualan-detail/:id_transaksi/:tipe_transaksi',
      name: 'PembayaranPenjualanDetail',
      component: PembayaranDetailPenjualan,
      meta: {
        auth : true,
      }
    },
    {
      path: '/penjualan/list/selesai-penjualan-detail/:id_transaksi/:tipe_transaksi',
      name: 'SelesaiPenjualanDetail',
      component: PembayaranDetailPenjualan,
      meta: {
        auth : true,
      }
    },
    {
      path: '/penjualan/transaksi-detail/:id_transaksi',
      name: 'TransaksiDetailPenjualan',
      component: TransaksiDetailPenjualan,
      meta: {
        auth : true,
      }
    },
    {
      path: '/penjualan/create-packing-transaksi/:id_transaksi',
      name: 'CreatePenjualanPackingTransaksi',
      component: CreatePenjualanPackingTransaksi,
      meta: {
        auth : true,
      }
    },
    {
      path: '/penjualan/print-invoice/:id_transaksi',
      name: 'PrintInvoicePenjualan',
      component: PrintInvoicePenjualan,
      meta: {
        auth : true,
      }
    },
    {
      path: '/laporan/penjualan/daftar-penjualan',
      name: 'LaporanDaftarPenjualan',
      component: LaporanPenjualan,
      meta: {
        auth : true,
      }
    },
    {
      path: '/laporan/penjualan/per-produk',
      name: 'LaporanDaftarPenjualanPerProduk',
      component: LaporanPenjualan,
      meta: {
        auth : true,
      }
    },
    {
      path: '/laporan/penjualan/per-pelanggan',
      name: 'LaporanDaftarPenjualanPerPelanggan',
      component: LaporanPenjualan,
      meta: {
        auth : true,
      }
    },
    {
      path: '/master/kontak-pelanggan',
      name: 'KontakPelanggan',
      component: KontakList,
      meta: {
        auth : true,
      }
    },
    {
      path: '/master/kontak-supplier',
      name: 'KontakSupplier',
      component: KontakList,
      meta: {
        auth : true,
      }
    },
    {
      path: '/master/kontak-karyawan',
      name: 'KontakKaryawan',
      component: KontakList,
      meta: {
        auth : true,
      }
    },
    {
      path: '/master/kontak/kontak-baru',
      name: 'KontakBaru',
      component: KontakForm,
      meta: {
        auth : true,
      }
    },
    {
      path: '/master/kontak/kontak-detail/:id_kontak',
      name: 'KontakDetail',
      component: KontakDetail,
      meta: {
        auth : true,
      }
    },
    {
      path: '/master/kontak/kontak-edit/:id_kontak',
      name: 'KontakEdit',
      component: KontakForm,
      meta: {
        auth : true,
      }
    },
    {
      path: '/laporan/produk/daftar-produk',
      name: 'LaporanDaftarProduk',
      component: LaporanProduk,
      meta: {
        auth : true,
      }
    },
    {
      path: '/laporan/produk/rincian-persediaan',
      name: 'LaporanRincianPersediaan',
      component: LaporanProduk,
      meta: {
        auth : true,
      }
    },
    {
      path: '/settings/user',
      name: 'UserManagement',
      component: UserManagement,
      meta: {
        auth : true,
      }
    },
    {
      path: '/user/new-user',
      name: 'NewUser',
      component: NewUser,
      meta: {
        auth : true,
      }
    },
    {
      path: '/user/user-detail/:id_user',
      name: 'UserDetail',
      component: UserDetail,
      meta: {
        auth : true,
      }
    },
    {
      path: '/finance/daftar-akun',
      name: 'DaftarAkun',
      component: DaftarAkun,
      meta: {
        auth : true,
      }
    },
    {
      path: '/finance/new-account',
      name: 'NewAccount',
      component: FormAkun,
      meta: {
        auth : true,
      }
    },
    {
      path: '/finance/transfer-balance',
      name: 'TransferBalance',
      component: TransferBalance,
      meta: {
        auth : true,
      }
    },
    {
      path: '/finance/akun-detail/:id_coa',
      name: 'DetailAccount',
      component: AkunDetail,
      meta: {
        auth : true,
      }
    },
    {
      path: '/finance/edit-akun/:id_coa',
      name: 'EditAccount',
      component: FormAkun,
      meta: {
        auth : true,
      }
    },
    {
      path: '/finance/laba-rugi',
      name: 'LabaRugi',
      component: LabaRugi,
      meta: {
        auth : true,
      }
    },
    {
      path: '/finance/neraca',
      name: 'Neraca',
      component: Neraca,
      meta: {
        auth : true,
      }
    },
    {
      path: '/pembiayaan/list',
      name: 'DaftarPembiayaan',
      component: DaftarPembiayaan,
      meta: {
        auth : true,
      }
    },
    {
      path: '/pembiayaan/baru',
      name: 'PembiayaanBaru',
      component: FormPembiayaan,
      meta: {
        auth : true,
      }
    },
    {
      path: '/pembiayaan/detail/:id_pembiayaan',
      name: 'PembiayaanDetail',
      component: FormPembiayaan,
      meta: {
        auth : true,
      }
    },
    {
      path: '/settings/pemetaan-akun',
      name: 'PemetaanAkun',
      component: PemetaanAkun,
      meta: {
        auth : true,
      }
    }

  ]
});

router.beforeEach((to, from, next) => {
  if (to.meta.auth && !auth.checkAuth()) {
    next('/login');
	} else {
    window.localStorage.setItem('last_route', from.path);
		if (window.localStorage.getItem('token')) {
			
    }
		next()
	}
});


export default router;



// WEBPACK FOOTER //
// ./src/router/index.js